import React from "react";
import { EntityContextInterface } from "module/entity/context/entity/EntityContext";

export type AssessmentContextInterface = EntityContextInterface;

const AssessmentContext = React.createContext(<AssessmentContextInterface>{});

export default AssessmentContext;
